export const ROUTES = {
  CONFIGURATION_BASE: "/configuration",
  CONFIGURATION_LIST: "/configuration/list",
  CONFIGURATION_DETAILS: "/configuration/details",
  CONFIGURATION_SCREEN_DETAILS: "/configuration/screen/details",
  CONFIGURATION_SCREEN_TYPES_LIST: "/configuration/screen-types/list",
  CONFIGURATION_COMPONENT_TYPES_LIST: "/configuration/component-types/list",
};
